<template>
  <div class="monthly-charge-report">
    <el-card class="box-card">
      <el-tabs v-model="reportTabName">
        <el-tab-pane label="Monthly Fee" name="monthlyfee">
          <MonthlyFee :project="project"/>
        </el-tab-pane>
        <el-tab-pane label="Compliance Fee" name="compliancefee">
          <ComplianceFee :project="project"/>
        </el-tab-pane>
        <el-tab-pane label="Visualization" name="visualization">
          <MonthlyChargeVisualization/>
        </el-tab-pane>

      </el-tabs>

    </el-card>
  </div>
</template>

<script>
import ComplianceFee from "./compliance-fee-report";
import MonthlyChargeVisualization from "./monthly-charge-visualization";
import MonthlyFee from "./monthly-fee-report";
export default {
  components:{
    ComplianceFee,
    MonthlyFee,
    MonthlyChargeVisualization
  },
  props:{
    project: String
  },
  
  computed: {
    roleSuperAdmin() {
      return this.roleAuth([this.role.spadmin]);
    },
 
  },
  data(){
    return {
      reportTabName: "monthlyfee"
    }
  },
  methods:{},
  created(){}
}
</script>

<style lang="scss">

</style>